// extracted by mini-css-extract-plugin
module.exports = {"Terms":"AuthTermsNotice_Terms__CJg5H"};